module.exports = __webpack_public_path__ + "img/cutePet.57dac773.png";